import { useState } from 'react';
import { X, Sparkles, Trash2 } from 'lucide-react';
import { useOrg } from '../context/OrgContext';
import { useRequests } from '../context/RequestsContext';
import { WorkfrontAiChat, clearWorkfrontChatHistory } from './WorkfrontAiChat';
import { NlqChatPanel } from '../nlq/components/NlqChatPanel';
type AiMode = 'workfront' | 'nlq';
interface Props {
  onClose: () => void;
}
const WORKFRONT_ORG_NAME = 'Workfront AdobeRM';
export function AiChatSidebar({
  onClose
}: Props) {
  const [mode, setMode] = useState<AiMode>('nlq');
  const {
    selectedOrg
  } = useOrg();
  const {
    requests,
    touchpoints
  } = useRequests();
  const isWorkfrontOrg = selectedOrg?.orgName === WORKFRONT_ORG_NAME || selectedOrg?.imsOrgId?.includes('workfront');
  const handleClearChat = () => {
    if (mode === 'workfront') {
      clearWorkfrontChatHistory();
    } else {
      localStorage.removeItem('ai-chat-nlq');
    }
    window.location.reload();
  };
  return <div className="ai-sidebar ai-sidebar-enter" onClick={e => e.stopPropagation()} data-id="element-63" data-mp="hnc3cgg09pm1">
      {/* Header */}
      <div className="ai-sidebar-header" data-id="element-64" data-mp="181ut5s4ugr75">
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }} data-id="element-65" data-mp="180t9iz9riwdt">
          <Sparkles size={16} style={{
          color: '#7c3aed'
        }} data-id="element-66" data-mp="uazh66z1ttzc" />
          <span style={{
          fontWeight: 700,
          fontSize: 14,
          color: '#1a1a2e'
        }} data-id="element-67" data-mp="u8d9m7c5reh4">
            {mode === 'workfront' ? 'Workfront AI' : 'OnDemand AI'}
          </span>
        </div>
        <div style={{
        display: 'flex',
        gap: 4
      }} data-id="element-68" data-mp="kaqh2i1xroeo">
          <button onClick={handleClearChat} title="New conversation" className="ai-icon-btn" data-id="element-69" data-mp="pb4ru7ux9cge">
            <Trash2 size={14} data-id="element-70" data-mp="bblmfmthwf7s" />
          </button>
          <button onClick={onClose} title="Close" className="ai-icon-btn" data-id="element-71" data-mp="bcwvo25pmf6a">
            <X size={16} data-id="element-72" data-mp="g9wvhvbyuloy" />
          </button>
        </div>
      </div>

      {/* Mode Toggle */}
      <div className="ai-mode-section" data-id="element-73" data-mp="25pd0qzmrrn9k">
        <div className="ai-mode-toggle" data-id="element-74" data-mp="25qebt43sc9ra">
          <button className={`ai-mode-pill ${mode === 'nlq' ? 'active' : ''}`} onClick={() => setMode('nlq')} data-id="element-75" data-mp="2aofz6188uv8k">
            OnDemand AI
          </button>
          <button className={`ai-mode-pill ${mode === 'workfront' ? 'active' : ''}`} disabled={!isWorkfrontOrg} onClick={() => setMode('workfront')} title={isWorkfrontOrg ? 'Switch to Workfront AI' : `Requires ${WORKFRONT_ORG_NAME} org to be selected`} data-id="element-76" data-mp="248h6mtt7d7pq">
            Workfront AI
          </button>
        </div>
        <div className="ai-subtitle" data-id="element-77" data-mp="2rx8sz4k42vul">
          {mode === 'workfront' ? 'Workfront assistant' : 'AI-powered data assistant'}
        </div>
      </div>

      {/* Mode Content */}
      {mode === 'workfront' ? <WorkfrontAiChat onError={() => {}} data-id="element-78" data-mp="2i5vwfzndbhi8" /> : <NlqChatPanel requests={requests} touchpoints={touchpoints} onError={() => {}} data-id="element-79" data-mp="2d8cjr46bjcse" />}
    </div>;
}